<template>
  <div class="container">
    <div class="form-group">
      <label for="">系統名稱</label>
      <input type="text" class="form-control" v-model="systemName">
    </div>
    <div class="form-group">
      <label for="">所屬區域</label>
      <select name="" id="" class="form-control" v-model="systemArea">
        <option :value="item.value" v-for="item in area">{{ item.label }}</option>
      </select>
    </div>
    <!-- <div class="form-group">
      <label for="">所屬單位</label>
      <v-select :options="department"/>
    </div> -->
    <div class="form-group">
      <label for="">管理者</label>
      <select class="form-control" name="" id="" v-model="systemAdmin">
        <option :value="item.value" v-for="item in user">{{ item.label }}</option>
      </select>
    </div>
    <!-- <div class="form-group">
      <label for="">預設登入方式</label>
      <div class="form-check">
        <label class="form-check-label">
          <input class="form-check-input" v-model="systemLoginMode" type="radio" name="defaultLogin" value="password">
          密碼
        </label>
        <label class="form-check-label">
          <input class="form-check-input" v-model="systemLoginMode" type="radio" name="defaultLogin" value="barcode">
          條碼
        </label>
        <label class="form-check-label">
          <input class="form-check-input" v-model="systemLoginMode" type="radio" name="defaultLogin" value="fingerprint">
          指紋
        </label>
      </div>
    </div> -->
    <!-- <div class="form-group">
      <label for="">其他登入方式</label>
      <label class="form-check-label">
        <input type="checkbox" class="form-check-input">
        帳號
      </label>
      <label class="form-check-label">
        <input type="checkbox" class="form-check-input">
        密碼
      </label>
    </div> -->
    <!-- <div class="form-group">
      <label for="">低安全量與過期EMAIL提醒時間(天)</label>
      <input type="number" class="form-control" v-model="systemAlertOudatedDay">
    </div>
    <div class="form-group">
      <label for="">系統閒置時間(分)</label>
      <input type="number" class="form-control">
    </div> -->
    <!-- <div class="form-group">
      <label for="">藥盒開啟閒置時間</label>
      <input type="text" class="form-control">
    </div> -->
    <!-- <div class="form-group">
      <label class="form-check-label">
        <input type="checkbox" class="form-check-input" v-model="systemInventoryBeforeFetch">
        取藥時確認藥物庫存量
      </label>
      <label class="form-check-label">
        <input type="checkbox" class="form-check-input" v-model="systemMedRecordInput">
        需輸入病歷號
      </label>
      <label class="form-check-label">
        <input type="checkbox" class="form-check-input" v-model="systemReturnOriginalCmpn">
        退回原藥盒
      </label>
    </div> -->
    <button class="btn btn-primary" @click="save">儲存設定</button>
  </div>
</template>

<script>

export default {
  name: 'TagDetail',
  data() {
    return {
      // system attribute
      systemName: '',
      systemArea: '',
      systemAdmin: '',
      systemLoginMode: [],
      systemAlertOudatedDay: 0,
      area: [],
      department: [],
      user: [],
      systemInventoryBeforeFetch: false,
      systemMedRecordInput: false,
      systemReturnOriginalCmpn: false,
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
  },
  methods: {
    getArea() {
      return this.instance.get('/api/area/')
      .then((res) => {
        res.data.forEach((data) => {
          this.area.push({
            label: data.name,
            value: data.id,
          });
        });
      });
    },
    getDepartment() {
      return this.instance.get('/api/department/')
      .then((res) => {
        res.data.forEach((data) => {
          this.department.push({
            label: data.name,
            value: data.id,
          });
        });
      });
    },
    getUser() {
      return this.instance.get('/api/user/')
      .then((res) => {
        res.data.results.forEach((data) => {
          this.user.push({
            label: data.username,
            value: data.id,
          });
        });
      });
    },
    save() {
      this.instance.patch(`/api/system/${this.rowData.id}/`, {
        name: this.systemName,
        area: this.systemArea,
        admin: this.systemAdmin,
        login_mode: this.systemLoginMode,
        alert_outdated_day: this.systemAlertOudatedDay,
        check_amount_first: this.systemInventoryBeforeFetch,
        return_to_original_cmpn: this.systemReturnOriginalCmpn,
        med_record_input: this.systemMedRecordInput,
      })
      .then((res) => {
        console.log(res);
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功',
        });
        this.$parent.refresh();
      });
    },
  },
  async created() {
    await this.getArea();
    await this.getDepartment();
    await this.getUser();
    if (this.rowData.admin !== null) this.systemAdmin = this.rowData.admin.id;
    if (this.rowData.area !== null) this.systemArea = this.rowData.area.id;
    this.systemName = this.rowData.name;
    this.systemAlertOudatedDay = this.rowData.alert_outdated_day;
    this.systemLoginMode = this.rowData.login_mode;
    this.systemInventoryBeforeFetch = this.rowData.check_amount_first;
    this.systemMedRecordInput = this.rowData.med_record_input;
    this.systemReturnOriginalCmpn = this.rowData.return_to_original_cmpn;
  },
};
</script>


// WEBPACK FOOTER //
// TagDetail.vue?045f6e33